export default "__VITE_ASSET__4R$QeH$j__"